import { RG_TYPE } from "@project-rouge/rg-core";
function isBuildingEmpty(building) {
  const hasCores = building.children.some((c) => c.type === RG_TYPE.Core);
  if (!hasCores)
    return true;
  const hasEntrances = building.children.some((c) => c.type === RG_TYPE.Entrance);
  if (!hasEntrances)
    return true;
  const hasApartments = building.children.some((c) => c.type === RG_TYPE.Apartment);
  if (!hasApartments)
    return true;
  return false;
}
export {
  isBuildingEmpty
};
//# sourceMappingURL=index187.js.map
